import NaptimeResource from './NaptimeResource';

class EnterpriseContractProvisioningActions extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseContractProvisioningActions.v1';
}

export default EnterpriseContractProvisioningActions;
